import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Unexpected error" };
  }

  componentDidCatch(error) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error("UI ErrorBoundary:", error);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container eco-section">
          <div className="eco-card" style={{ textAlign: "center" }}>
            <h2 style={{ marginTop: 0 }}>Home failed to load</h2>
            <p style={{ color: "#475569" }}>{this.state.message}</p>
            <button className="eco-btn" onClick={() => window.location.reload()}>
              Reload
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
